import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoute, StaticRoutes } from '@news-mono/web-common'
import { layout } from '../../App.routing'

const createEmailPreferencePage: StaticRoute<TheWestSection> = (services) => {
    const isEmailPreferenceCentreEnabled =
        services.store.getState().toggles['email-preference-centre']
    if (!isEmailPreferenceCentreEnabled) return null

    return {
        kind: 'page',
        heading: 'Email Preferences',
        hideHeading: true,
        pageType: 'static',
        adTargeting: {
            pageId: 'email-preferences',
            adUnitPath: '',
            ssAdUnits: [],
            topics: [],
        },
        section: 'default',
        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    verticalGutters: true,
                    horizontalGutters: false,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'thor',
                            props: {
                                containerWidth: '100%',
                                horizontalGutters: true,
                                hasBackgroundFill: true,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'email-preference',
                                        props: {},
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}

export const getEmailPreferenceRouteInfo: StaticRoutes<TheWestSection> = {
    '/manage-email-preferences': createEmailPreferencePage,
}
